这是常量编辑界面，直接应用即可实现功能模块的常量管理

<template>
  <div>
    <el-tag v-if="checkVal(value)" :type="getTagType(value)" size="mini">{{
      getTagText(value)
    }}</el-tag>

    <div
      v-if="
        relType == 'tags' &&
        value != null &&
        value != undefined &&
        value.length > 0
      "
    >
      <span
        v-for="(item, idx) in value"
        v-bind:key="idx"
        style="margin-right: 8px"
      >
        <el-tag :type="getTagType(item)" size="mini">{{
          getTagText(item)
        }}</el-tag>
      </span>
    </div>
  </div>
</template>


<script>
import constantCache from "../cache.js";

export default {
  name: "CcConstantLabel",
  props: {
    type: {
      type: String,
      required: false,
    },
    value: [String, Number, Boolean, Array],
    options: Object,
    code: String, //常量的code
    api: String,
    valueKey: {
      type: String,
      default: "val",
    },
    textKey: {
      type: String,
      default: "title",
    },
    afterRequest: {
      type: Function | String,
      default: "",
    },
  },
  data() {
    return {
      relType: "tag",
      opts: [],
    };
  },
  methods: {
    checkVal(value) {
      //relType=='tag' && value != null && value != undefined && ( value.length > 0 || (!(value instanceof String) && value >=0))
      if (this.relType != "tag") return false;
      if (value == null || value == undefined) return false;
      if (typeof value == "string" && value.length < 1) return false;
      if (typeof value == "number" && value < 0) return false;
      return true;
    },
    getTagType(val) {
      let type = "info";
      if (this.options) {
        for (let opt in this.options) {
          if (opt == val) {
            type = this.options[opt];
          }
        }
      }
      return type;
    },
    getTagText(val) {
      let text = null;
      if (this.opts) {
        this.opts.forEach((opt) => {
          if (opt.val == val || opt.val == val + "") {
            let t = opt.title;
            //如果不是中文就获取对应的，找不到默认中文
            if (this.$lange && this.$lange != "zh") {
              if(opt[this.$lange]){
                t = opt[this.$lange];
              }
            }
            text = t;
          }
        });
      }
      if (!text) text = val; //找不到则返回值
      return text;
    },
    loadData() {
      constantCache
        .load(this, this.api, this.code, this.afterRequest)
        .then((res) => {
          this.opts = res;
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.loadData();
    if (this.value instanceof Array) {
      this.relType = "tags";
    }
    if (this.type) {
      this.relType = this.type;
    }
  },
};
</script>

<style>
</style>
